// extracted by mini-css-extract-plugin
module.exports = {"button":"searchbar_button__Y7nMJ"};